import { Dispatch } from 'redux';
import { MenuActionType } from './types';

export const setCollapse = (c: boolean) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: MenuActionType.MENU,
        collapsed: c
    });
};
